<script>
export default {
  props: {
    filter: Object,
    sizes: Array
  }
}
</script>

<template>
  <div>
    <h5 class="m-t-md m-b-xs">Size</h5>
    <div class="m-b">
      <v-select
          placeholder="Select size"
          :multiple="true"
          :options="sizes"
          v-model="filter.size"
      ></v-select>
    </div>
  </div>
</template>
